import { BRAND_NAME } from '../components/ui/Brand';
import { useEffect } from 'react';

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} — ${BRAND_NAME}` : BRAND_NAME;
    return () => { document.title = BRAND_NAME; };
  }, [title]);
}
